import {
  clearInputField,
  clearSelectField,
  getQueryStringParameter,
} from '../../../helpers';

const clearBeneficialOwnerFormFields = ($fields) => {
  $('input', $fields).each((_, inputElement) => {
    clearInputField(inputElement);
  });

  $('select', $fields).each((_, selectElement) => {
    clearSelectField(selectElement);
  });
};

$(() => {
  const $form = $('form#legal-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'beneficial_ownership') {
    return;
  }
  const $investorIsBeneficialOwnerRadio = $('#investor_is_beneficial_owner_buttons input[type=radio]', $form);
  const $beneficialOwnerTypeButtons = $('#beneficial_owner_type_buttons', $form);
  const $beneficialOwnerTypeCheckBoxes = $('#beneficial_owner_type_buttons input[type=checkbox]', $form);
  const $legalBeneficialOwnerFields = $('#legal_beneficial_owner_fields', $form);
  const $naturalBeneficialOwnerFields = $('#natural_beneficial_owner_fields', $form);

  $investorIsBeneficialOwnerRadio.on('change', (e) => {
    if (e.target.value === 'false' && e.target.checked) {
      $beneficialOwnerTypeButtons.addClass('d-none');
      $naturalBeneficialOwnerFields.addClass('d-none');
      $legalBeneficialOwnerFields.addClass('d-none');

      clearBeneficialOwnerFormFields($beneficialOwnerTypeButtons);
      clearBeneficialOwnerFormFields($naturalBeneficialOwnerFields);
      clearBeneficialOwnerFormFields($legalBeneficialOwnerFields);
    } else if (!e.target.checked || e.target.value === 'true') {
      $beneficialOwnerTypeButtons.removeClass('d-none');
    }
  });

  $beneficialOwnerTypeCheckBoxes.on('change', (e) => {
    if (e.target.checked) {
      if (e.target.value === 'legal') {
        $legalBeneficialOwnerFields.removeClass('d-none');
      } else if (e.target.value === 'natural') {
        $naturalBeneficialOwnerFields.removeClass('d-none');
      }
    } else {
      if (e.target.value === 'legal') {
        $legalBeneficialOwnerFields.addClass('d-none');
        clearBeneficialOwnerFormFields($legalBeneficialOwnerFields);
      } else if (e.target.value === 'natural') {
        $naturalBeneficialOwnerFields.addClass('d-none');
        clearBeneficialOwnerFormFields($naturalBeneficialOwnerFields);
      }
    }
  });

  $form.on('submit', (e) => {
    $('#beneficial_owner_type_buttons.d-none', $form).remove();
  });
});
